import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { AppProviders } from './app/providers';
import { applyTheme } from './lib/theme';
import './styles/index.css';

const storedTheme = window.localStorage.getItem('hospital.theme');
applyTheme(
  storedTheme === 'light' || storedTheme === 'dark'
    ? storedTheme
    : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
);

const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('Application root element was not found');

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
